import React, { Component } from 'react';
import image2base64 from 'image-to-base64';
import { fabric } from "fabric";
import Resources from '../assets/Resources';
import './FabricJs.scss';

Number.prototype.between = function(a, b) {
  var min = Math.min.apply(Math, [a, b]),
    max = Math.max.apply(Math, [a, b]);
  return this > min && this < max;
};

class FabricJs extends Component {

  constructor() {
    super();
    this.state = {
      paths: [],
      polygons: [],
      activeImageObject: null,
      image: Resources.car,
      imageTop: 50,
      imageLeft: 50,
      scaleX: 0.2,
      scaleY: 0.2
    };
    this.canvasRef = React.createRef('canvas');
    this.containerRef = React.createRef('div');
  }

  componentWillMount() {
    window.addEventListener("resize", this.resize);
  }

  componentDidMount() {
    this.fabricCanvas = new fabric.Canvas('Fabric-canvas', {
      width: this.containerRef.current.clientWidth,
      height: this.containerRef.current.clientHeight
    });

    image2base64(this.state.image)
    .then(response => {
      let image = new fabric.Image();
      let re = /(?:\.([^.]+))?$/;
      let ext = re.exec(this.state.image)[1];

      image.setSrc(`data:image/${ext};base64,${response}`, (response) => {
        this.fabricCanvas.add(response).setActiveObject(response);
      }, {
        left: 50,
        top: 50,
        angle: 0,
        width: image.width,
        height: image.height,
        opacity: 1,
        scaleX: 0.2,
        scaleY: 0.2,
        lockScalingFlip: true,
        hasRotatingPoint: false
      });
      
    });
    this.fabricCanvas.on('mouse:dblclick', this.onDoubleClick);
    this.fabricCanvas.on('object:scaled', this.onObjectScaled);
    this.fabricCanvas.on('object:scaling', this.onObjectScaling);
    this.fabricCanvas.on('object:moved', this.onObjectMoved);
    this.fabricCanvas.on('object:moving', this.onObjectMoving);
  }

  onObjectScaled = (e) => {
    let activeObject = e.target;

    this.setState({
      scaleX: activeObject.scaleX,
      scaleY: activeObject.scaleY,
      imageTop: activeObject.top,
      imageLeft: activeObject.left
    }, () => {
      this.connectPoints();
    })
  }

  onObjectScaling = (e) => {
    let activeObject = e.target;

    this.setState({
      scaleX: activeObject.scaleX,
      scaleY: activeObject.scaleY,
      imageTop: activeObject.top,
      imageLeft: activeObject.left
    }, () => {
      this.connectPoints();
    })
  }

  onObjectMoved = (e) => {
    let activeObject = e.target;

    this.setState({
      imageTop: activeObject.top,
      imageLeft: activeObject.left
    }, () => {
      this.connectPoints();
    })
  }

  onObjectMoving = (e) => {
    let activeObject = e.target;

    this.setState({
      imageTop: activeObject.top,
      imageLeft: activeObject.left
    }, () => {
      this.connectPoints();
    })
  }

  onDoubleClick = (e) => {
    let activeObject = e.target;
    let x = ((this.fabricCanvas._previousPointer.x - activeObject.left ) / activeObject.scaleX) ;
    let y = ((this.fabricCanvas._previousPointer.y - activeObject.top ) / activeObject.scaleY);
    let canvas = document.getElementsByClassName("upper-canvas")[0];
    let ctx = canvas.getContext("2d");
    let temp_paths = JSON.parse(JSON.stringify(this.state.paths));

    if (temp_paths.length > 0){
      let last_path = temp_paths[temp_paths.length-1];
      let first_x = last_path.path[0].x;
      let first_y = last_path.path[0].y;
      if(x.between( first_x + 20 , first_x - 20) && y.between(first_y + 20 , first_y - 20)){
        last_path.path.push({x: x, y: y});
        last_path.closed = true;
      } else {
        if (last_path.closed) {
          temp_paths.push({
            path: [{x: x, y: y}],
            closed: false
          })
        } else {
          last_path.path.push({x: x, y: y})
        }
      }
    }
    else {
      temp_paths.push({
        path: [{x: x, y: y}],
        closed: false,
        label: ''
      })
    }
    
    this.setState({
      activeImageObject: activeObject,
      paths: temp_paths
    }, () => {
      this.connectPoints();
      console.log(temp_paths);
    })
  }

  resize = () => {
    let canvas = document.getElementById("Fabric-canvas");
    let container = document.getElementById("FabricJs-container");
    let width = container.clientWidth;
    let height = container.clientHeight;

    canvas.width = width;
    canvas.height = height;
  }

  connectPoints = () => {

    let canvas = document.getElementsByClassName("upper-canvas")[0];
    let ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    this.state.paths.forEach((item) => {
      ctx.beginPath();
      let region = new Path2D()
      item.path.forEach((element, index) => {
        if(index>0) {
          let start_x = (item.path[index-1].x * this.state.scaleX) + this.state.imageLeft;
          let start_y = (item.path[index-1].y * this.state.scaleY) + this.state.imageTop;
          let end_x = (element.x * this.state.scaleX) + this.state.imageLeft;
          let end_y = (element.y * this.state.scaleY) + this.state.imageTop;
          if (index == 1) {
            region.moveTo( start_x, start_y);
          }
          region.lineTo( end_x, end_y);
          ctx.moveTo( start_x, start_y);
          ctx.lineTo( end_x, end_y);
          ctx.strokeStyle = 'white';
          ctx.stroke();
          if (index == item.path.length - 1 && item.path.length > 2) {
            let first_x = (item.path[0].x * this.state.scaleX) + this.state.imageLeft;
            let first_y = (item.path[0].y * this.state.scaleY) + this.state.imageTop;
            ctx.beginPath();
            ctx.strokeStyle = item.closed ? 'white' : 'red';
            ctx.moveTo( end_x, end_y);
            ctx.lineTo( first_x, first_y);
            ctx.stroke();
            region.lineTo(first_x, first_y);
            ctx.fillStyle = '#4f950e4d';
            ctx.fill(region, 'evenodd');
          }
        }
      });
    })
  }

  render() {
    return (
      <div ref={this.containerRef} id="FabricJs-container">
        <canvas ref={this.canvasRef} id="Fabric-canvas" / >
      </div>
    )
  }
};

export default FabricJs;